__turbopack_context__.v({
  "brand": "Footer-module__pp8SeW__brand",
  "brandLogo": "Footer-module__pp8SeW__brandLogo",
  "column": "Footer-module__pp8SeW__column",
  "columnTitle": "Footer-module__pp8SeW__columnTitle",
  "columns": "Footer-module__pp8SeW__columns",
  "container": "Footer-module__pp8SeW__container",
  "content": "Footer-module__pp8SeW__content",
  "copy": "Footer-module__pp8SeW__copy",
  "link": "Footer-module__pp8SeW__link",
  "links": "Footer-module__pp8SeW__links",
  "separator": "Footer-module__pp8SeW__separator",
  "socials": "Footer-module__pp8SeW__socials",
  "tagline": "Footer-module__pp8SeW__tagline",
  "top": "Footer-module__pp8SeW__top",
});
